import store from '../../../store/store';
import ChatService from '../../../service/ChatService';
import { fetchModel } from '../../../utils';
import { pick } from 'lodash';


let chatService = new ChatService();

const USER_TYPE = 'guide-user';

let currentUser = () => ({
	type: USER_TYPE,
	id: store.state.user.id,
	name: store.state.user.name,
	email: store.state.user.email,
	guideProduct: true,
});


export default class ChatGroup {

	constructor(chat, socket) {
		this.id = chat.id;
		this.lastMessage = chat.lastMessage;
		this.firstUnseenMessage = chat.firstUnseenMessage;
		this.messages = [];
		this.subscriptions = [];
		this.onBroadcastedMessages = () => {};
		this.onPushedMessage = () => {};
	}

	connect(socket) {
		this.socket = socket;

		this.unsubscribe();

		this.subscriptions = [
			this.subscribeToBroadcastedMessages(),
			this.subscribeToSeenMessages()
		];
	}

	disconnect() {
		this.unsubscribe();
		this.subscriptions = [];
	}

	unsubscribe() {
		this.subscriptions.forEach(sub => sub.unsubscribe());
	}

	subscribeToBroadcastedMessages() {
		return this.socket.subscribe(`/topic/${this.id}/broadcast-message`, (res) => {
			let message = JSON.parse(res.body);
			this.pushBroadcastedMessage(message);
		});
	}

	subscribeToSeenMessages() {
		return this.socket.subscribe(`/topic/${this.id}/seen-messages`, (res) => {
			this.firstUnseenMessage = null;
		});
	}

	pushMessage(message) {
		this.messages.push(message);
		this.lastMessage = message;
		if (this.onPushedMessage)
			this.onPushedMessage(message);
	}

	pushBroadcastedMessage(message) {
		if (!this.firstUnseenMessage) this.firstUnseenMessage = message;

		if (!this.isOwnMessage(message)) {
			this.pushMessage(message);
			if (this.onBroadcastedMessage)
				this.onBroadcastedMessage(message);
		}
	}

	async readUnseenMessages() {
		try {
			if (this.firstUnseenMessage && !this.isOwnMessage(this.firstUnseenMessage)) {
				await chatService.readUnseenMessages(this.id);
				this.firstUnseenMessage = null;
			}
		} finally {
		}
	}

	async fetchMessages() {
		this.messages = await fetchModel('mensagens', () => chatService.findMessagesByGroupId(this.id));
		return this.messages;
	}

	async sendMessage(messageText) {
		messageText = messageText.trim();
		if (!messageText) return;
		let message = { text: messageText, user: currentUser() };
		let {data} = await chatService.sendMessage(this.id, message);
		this.pushMessage(data);
	}

	isOwnMessage(message) {
		return store.state.user.id === message.user.id && message.user.userType === USER_TYPE;
	}

	hasUnseenMessages() {
		return this.firstUnseenMessage && !this.isOwnMessage(this.firstUnseenMessage);
	}

	toJSON() {
		return pick(this, ['id', 'lastMessage', 'firstUnseenMessage']);
	}
}



// WEBPACK FOOTER //
// ./src/components/shared/blumar-chat/ChatGroup.js